// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "tay-training.firebaseapp.com",
  "projectId": "tay-training",
  "storageBucket": "tay-training.appspot.com",
  "messagingSenderId": "920997780522",
  "appId": "1:920997780522:web:fee73e211c840027fbf753",
  "measurementId": "G-41PN7T74PS",
  "apiKey": "AIzaSyA_t6gy3Vz_xloORMBt94NtKE4rA0FCJk0"
};
